
import { SellCategoryCalculationParameter } from "@/utils/sell-category-calculation-parameter";
import Vue from "vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => SellCategoryCalculationParameter,
			required: true
		},
		disabled: Boolean,
		deleteDisabled: Boolean
	},
	methods: {
		onDelete() {
			this.$emit("delete");
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
